import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
    baseURL: API,
    timeout: 120000,
    withCredentials: true,
});

// Attach admin token from localStorage (fallback to cookie)
api.interceptors.request.use((config) => {
    const token = localStorage.getItem("admin_token");
    if (token) {
        config.headers = config.headers || {};
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});

export async function startCheckout({ item_type, item_id, quantity = 1, brand = "framework", customer_email = "", customer_name = "", metadata = {} }) {
    const origin_url = window.location.origin;
    const { data } = await api.post("/checkout/session", {
        item_type,
        item_id,
        quantity,
        origin_url,
        customer_email,
        customer_name,
        brand,
        metadata,
    });
    if (data?.url) {
        window.location.href = data.url;
    }
    return data;
}
